<template>
    <div class="co_user_detail">

        <div v-if="!hasUser">
            <div class="co_user_detail_empty">
                <h3>暂未获取到患者信息</h3>
                <div style="text-align: left;text-indent: 10px">
                    <div class="intro">UnionID: {{ unionid }}</div>
                    <div class="intro">手机号: {{ phone }}</div>
                    <div class="intro">企微ID: {{ external_userid }}</div>
                </div>
            </div>
        </div>
        <div v-else>
            <div class="co_user_detail_header">
                <div class="title">{{ baseinfo.userName }} <span class="role">客户</span></div>
                <div class="name">{{ baseinfo.userPhone }}</div>
                <div class="clear"></div>
                <div class="intro">UnionID: {{ unionid }}</div>
                <div class="intro" v-if="baseinfo.userPhone == ''">外部联系人手机号: {{ phone }}</div>
                <div class="intro">外部联系人ID: {{ external_userid }}</div>
            </div>

            <div class="co_user_detail_body">

                <div class="patient-info">
                    <div class="title">关联患者<span class="bind_from">{{ baseinfo.joinType }}</span></div>

                    <div class="patients-section">
                        <div :class="'patients-box '+(item.active ? 'active' : '')" v-for="(item,i) in baseinfo.basicsPatInfoVOS" @click="choosePatient(i)">
                            <span class="name">{{ item.patientName }}</span>
                            <span class="sex">{{ item.patientSex }}</span>
                            <span class="age">{{ item.patientAge }}</span>
                        </div>
                    </div>

                    <div class="info-section">
                        <div class="info-box" v-if="current_patient.patientAddress !== ''">
                            <div class="info-title">地区</div>
                            <div class="info-intro">{{ current_patient.patientAddress }}&nbsp;</div>
                        </div>
                        <div class="info-box" v-if="diagnosis && diagnosis.length > 0">
                            <div class="info-title">疾病诊断</div>
                            <div class="info-intro"><span v-for="item in diagnosis">{{item}}</span>&nbsp;</div>
                        </div>
                        <div class="info-box" v-if="history && history.length > 0">
                            <div class="info-title">&nbsp;&nbsp;&nbsp;&nbsp;</div>
                            <div class="info-intro" @click="historyShow = true"><span class="info-history">历史诊断 ></span></div>
                        </div>
                        <div class="info-box" v-if="healMethods && healMethods.length > 0">
                            <div class="info-title">&nbsp;&nbsp;&nbsp;&nbsp;</div>
                            <div class="info-intro">
                                <span class="info-tag" v-if="index < 3" v-for="(item,index) in healMethods">{{item.healMethod}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="clear"></div>

                <div class="co_user_detail_body_line"></div>

                <div class="content_list" v-if="visit && visit.visitTypeVOList && visit.visitTypeVOList.length > 0">
                    <div class="title">咨询就诊<span> </span></div>

                    <div class="tags">
                        <van-tabs :swipeable="true" v-model="category_index" @click="chooseCategory">
                            <van-tab v-for="item in visit.visitTypeVOList" :key="item.visitType" :title="item.visitTypeName"></van-tab>
                        </van-tabs>
                        <div class="clear"></div>
                    </div>

                    <div class="live-list-section" style="margin-top: 22px">
                        <div v-if="visit && visit.visitTypeVOList && visit.visitTypeVOList.length > 0" class="activity-list-section">
                            <div class="activity-list-section-container" :key="i" v-for="(item,i) in visit.visitDetailVOList">

                                <div class="activity-list-section-date" v-if="0 === category_id || item.visitType == category_id || (category_id == 1 && item.visitType==6)">{{item.visitTime}}</div>

                                <van-row class="activity-list-section-box" @click="go_consul_detail(item)" v-if="(item.visitType === 1 || item.visitType === 6) && [0,1,6].indexOf(category_index) !== -1">
                                    <div class="activity-list-section-left">
                                        <div v-if="['待支付','待接诊','咨询中'].indexOf(item.visitStatus) !== -1" class="activity-list-section-right-tags current">
                                            {{item.visitStatus}}
                                        </div>
                                        <div v-else-if="['已退诊','超时未接诊','已退款'].indexOf(item.visitStatus) !== -1" class="activity-list-section-right-tags danger">
                                            {{item.visitStatus}}
                                        </div>
                                        <div v-else-if="['已取消'].indexOf(item.visitStatus) !== -1" class="activity-list-section-right-tags cancel">
                                            {{item.visitStatus}}
                                        </div>
                                        <div v-else-if="['已完成','预约成功'].indexOf(item.visitStatus) !== -1" class="activity-list-section-right-tags end">
                                            {{item.visitStatus}}
                                        </div>
                                        <div v-else class="activity-list-section-right-tags end">
                                            {{item.visitStatus}}
                                        </div>
                                        <div class="activity-list-section-title">{{item.visitTypeName}}</div>
                                        <div class="activity-list-section-info">{{item.doctorName}} {{item.hospitalName}} {{item.deptName}}</div>
                                    </div>
                                    <div class="clear"></div>
                                </van-row>

                                <van-row class="activity-list-section-box" v-if="item.visitType === 2 && [0,2].indexOf(category_id) !== -1">
                                    <div class="activity-list-section-left">
                                        <div v-if="['就诊爽约','挂号已过期'].indexOf(item.visitStatus) !== -1" class="activity-list-section-right-tags danger">
                                            {{ visitTypeVOList[item.visitStatus] ? visitTypeVOList[item.visitStatus] : item.visitStatus }}
                                        </div>
                                        <div v-else-if="['取消预约'].indexOf(item.visitStatus) !== -1" class="activity-list-section-right-tags cancel">
                                            {{item.visitStatus}}
                                        </div>
                                        <div v-else-if="['预约挂号','挂号已过期','预约成功','待接诊','挂号成功','就诊完毕'].indexOf(item.visitStatus) !== -1" class="activity-list-section-right-tags end">
                                            {{ visitTypeVOList[item.visitStatus] ? visitTypeVOList[item.visitStatus] : item.visitStatus }}
                                        </div>
                                        <div class="activity-list-section-title">{{item.visitTypeName}}</div>
                                        <div class="activity-list-section-info">{{item.doctorName}} {{item.hospitalName}} {{item.deptName}}</div>
                                        <div class="activity-list-section-info" v-if="item.appointDate !== ''">就诊日期：{{item.appointDate}}</div>
                                    </div>
                                    <div class="clear"></div>
                                </van-row>

                                <van-row class="activity-list-section-box" v-if="item.visitType === 3 && [0,3].indexOf(category_id) !== -1">
                                    <div class="activity-list-section-left">
                                        <div v-if="['待取号就诊','待医生叫号','医生呼叫中','就诊中','挂号待支付','待审核'].indexOf(item.visitStatus) !== -1" class="activity-list-section-right-tags current">
                                            {{item.visitStatus}}
                                        </div>
                                        <div v-else-if="['挂号已退号','挂号失败','挂号义过期','审核未通过'].indexOf(item.visitStatus) !== -1" class="activity-list-section-right-tags danger">
                                            {{item.visitStatus}}
                                        </div>
                                        <div v-else-if="['挂号已取消'].indexOf(item.visitStatus) !== -1" class="activity-list-section-right-tags cancel">
                                            {{item.visitStatus}}
                                        </div>
                                        <div v-else-if="['就诊结束'].indexOf(item.visitStatus) !== -1" class="activity-list-section-right-tags end">
                                            {{item.visitStatus}}
                                        </div>
                                        <div class="activity-list-section-title">{{item.visitTypeName}}</div>
                                        <div class="activity-list-section-info">{{item.doctorName}} {{item.hospitalName}} {{item.deptName}}</div>
                                    </div>
                                    <div class="clear"></div>
                                </van-row>

                                <van-row class="activity-list-section-box" v-if="item.visitType === 4 && [0,4].indexOf(category_id) !== -1">
                                    <div class="activity-list-section-left">
                                        <div v-if="['住院中'].indexOf(item.visitStatus) !== -1" class="activity-list-section-right-tags danger">
                                            {{item.visitStatus}}
                                        </div>
                                        <div v-else-if="['已出院'].indexOf(item.visitStatus) !== -1" class="activity-list-section-right-tags end">
                                            {{item.visitStatus}}
                                        </div>
                                        <div class="activity-list-section-title">{{item.visitTypeName}}</div>
                                        <div class="activity-list-section-info">{{item.doctorName}} {{item.hospitalName}} {{item.deptName}}</div>
                                        <div class="activity-list-section-info" v-if="item.outHospitalDate !== ''">出院时间：{{item.outHospitalDate}}</div>
                                    </div>
                                    <div class="clear"></div>
                                </van-row>

                                <van-row class="activity-list-section-box" v-if="item.visitType === 5 && [0,5].indexOf(category_id) !== -1">
                                    <div class="activity-list-section-left">
                                        <div v-if="['待支付','待发货','待收货','待取药','药店自取'].indexOf(item.visitStatus) !== -1" class="activity-list-section-right-tags current">
                                            {{item.visitStatus}}
                                        </div>
                                        <div v-else-if="['已作废','已退货'].indexOf(item.visitStatus) !== -1" class="activity-list-section-right-tags danger">
                                            {{item.visitStatus}}
                                        </div>
                                        <div v-else-if="['已取消'].indexOf(item.visitStatus) !== -1" class="activity-list-section-right-tags cancel">
                                            {{item.visitStatus}}
                                        </div>
                                        <div v-else-if="['已收货','已取药'].indexOf(item.visitStatus) !== -1" class="activity-list-section-right-tags end">
                                            {{item.visitStatus}}
                                        </div>
                                        <div class="activity-list-section-title">{{item.visitTypeName}}</div>
                                        <div class="activity-list-section-info bottom8">{{item.doctorName}} {{item.hospitalName}} {{item.deptName}}</div>
                                        <div class="clear"></div>
                                        <div class="activity-list-order-list-section" v-for="val in item.prescriptionList">
                                            <div v-if="['待支付','待发货','待收货','待取药','药店自取'].indexOf(val.orderStatus) !== -1" class="activity-list-section-right-tags current">
                                                {{val.orderStatus}}
                                            </div>
                                            <div v-else-if="['已作废','已退货'].indexOf(val.orderStatus) !== -1" class="activity-list-section-right-tags danger">
                                                {{val.orderStatus}}
                                            </div>
                                            <div v-else-if="['已取消'].indexOf(val.orderStatus) !== -1" class="activity-list-section-right-tags cancel">
                                                {{val.orderStatus}}
                                            </div>
                                            <div v-else-if="['已收货','已取药'].indexOf(val.orderStatus) !== -1" class="activity-list-section-right-tags end">
                                                {{val.orderStatus}}
                                            </div>
                                            <div class="activity-list-section-title">订单号：{{val.orderId}}</div>
                                            <div class="activity-list-section-info" v-for="drug in val.drugInfoList">
                                                {{drug.drugName}} {{drug.drugSpec}}/{{drug.drugUnits}}
                                            </div>
                                            <div class="activity-list-section-title price">总金额：<span class="price_amount">¥{{val.total}}</span></div>
                                        </div>
                                    </div>
                                    <div class="clear"></div>
                                </van-row>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <van-dialog class="historyShow" v-model="historyShow" :showConfirmButton="false">
            <template slot="title">
                <div class="close-pop" @click="closeHistoryShow">
                    <img src="/static/bytx/popup_close_icon.svg" alt="">
                </div>
                <h3 align="left">历史诊断</h3>
                <div class="historyShowSection">
                    <div class="historyShowBox" v-for="item in history">
                        <div class="historyShowTitle">{{item.mainDiagnosis}}</div>
                        <div class="historyShowInfo" v-if="item.accessoryDiagnosisVOList && item.accessoryDiagnosisVOList.length > 0">
                            <span v-for="(v,i) in item.accessoryDiagnosisVOList">{{v.diagnosisName}} {{i == item.accessoryDiagnosisVOList.length - 1 ? '' : ','}}</span>
                        </div>
                        <div class="historyShowHospital">
                            {{item.hospitalName}}
                            <div style="float: right">{{item.diagnosisTime}}</div>
                        </div>
                    </div>
                </div>
            </template>

        </van-dialog>
    </div>
</template>
<script>
import Interface from '@/util/interface'
import videoListSkeleton from '@/skeleton/videoListSkeleton'
export default {
    name: 'live-list',
    components: {
        'video-list-skeleton': videoListSkeleton
    },
    data() {
        return {
            historyShow:false,
            hasUser:false,
            external_userid: '', // wm3nDlPwAAf1kiObhfIdKyaeTYFMtMnw
            unionid: '',
            phone: '',
            finished: [],
            live_types: [
                { id: '0', title: '全部' },
                { id: '1', title: '咨询' },
                { id: '2', title: '预约挂号' },
                { id: '3', title: '门诊' },
                { id: '4', title: '住院' },
                { id: '5', title: '互联网诊疗' }
            ],
            baseinfo: {},
            current_patient:{},
            diagnosis: [],
            healMethods: [],
            history:[],
            visit:{},
            category_index: 0,
            value: '',
            active: '',
            category_id: 0,
            recommend: [],
            list: [],
            column: [],
            backs: [],
            loading: true,
            page: 1,
            pageSize: 10,
            total_page: 1,
            record_id: 0,

            //
            // 预约挂号→预约成功
        // 待接诊→挂号成功
        // 取消预约→取消预约
        // 挂号已过期→就诊爽约
        // 就诊完毕→就诊完毕
            visitTypeVOList: {
                '预约挂号': '预约成功',
                '待接诊': '挂号成功',
                '取消预约': '取消预约',
                '挂号已过期': '就诊爽约',
                '就诊完毕': '就诊完毕',
            }
        }
    },
    methods: {
        closeHistoryShow(){
            this.historyShow = false
        },
        fetch(scene) {
            if (scene === 'baseinfo') {
                let params = {
                    external_userid: this.external_userid,
                    source_from: 'yyh'
                }
                if(this.$route.path.indexOf('gb_user_detail') > -1){
                    params.source_from = 'gaobo'
                }
                Interface.getData('postJson', Interface.gb_proxy.baseinfo, params).then(res => {
                    if(res.code === 0){
                        this.$nextTick(() => {
                            this.hasUser = true
                            this.baseinfo = res.data
                            this.unionid = res.data.unionId
                            this.phone = res.data.phone
                            if(res.data.basicsPatInfoVOS && res.data.basicsPatInfoVOS.length > 0){
                                this.current_patient = this.baseinfo.basicsPatInfoVOS[0]
                                this.choosePatient(0)
                            }
                        })

                    }else{
                        this.hasUser = false
                        this.unionid = res.data.unionId
                        this.phone = res.data.phone
                    }
                }, err => {
                    console.log(err)
                })
            }else if (scene === 'diagnosis') {
                Interface.getData('postJson', Interface.gb_proxy.disease, {
                    patientId: this.current_patient.patientId
                }).then(res => {
                    if(res.code === 0) {
                        this.$nextTick(() => {
                            this.diagnosis = res.data.diagnosis
                            this.healMethods = res.data.healMethods
                        })
                    }
                })
            }else if (scene === 'history') {
                Interface.getData('postJson', Interface.gb_proxy.history, {
                    patientId: this.current_patient.patientId
                }).then(res => {
                    if(res.code === 0) {
                        this.$nextTick(() => {
                            this.history = res.data
                        })
                    }
                })
            }else if (scene === 'visit') {
                Interface.getData('postJson', Interface.gb_proxy.visit, {
                    patientId: this.current_patient.patientId
                }).then(res => {
                    if(res.code === 0) {
                        this.$nextTick(() => {
                            res.data.visitTypeVOList.forEach((item, i) => {
                                if(item.visitTypeName === '图文咨询' || item.visitTypeName === '电话咨询' || item.visitTypeName === '视频咨询'){
                                    res.data.visitTypeVOList[i].visitTypeName = '咨询'
                                }
                            })
                            this.visit = res.data
                        })
                    }
                })
            }
        },
        chooseCategory() {
            this.category_id = this.visit.visitTypeVOList[this.category_index].visitType
        },
        choosePatient(index) {
            this.baseinfo.basicsPatInfoVOS.forEach((item, i) => {
                if(i === index){
                    item.active = true
                    this.current_patient = item
                    this.fetch('visit')
                    this.fetch('diagnosis')
                    this.fetch('history')
                }else{
                    item.active = false
                }
            })
        },
        go_consul_detail(item) {

            let patientName = ''
            this.baseinfo.basicsPatInfoVOS.forEach((item, i) => {
                if(item.active){
                    patientName = item.patientName
                }
            })

            let consul_baseinfo = {
                userName: patientName,
                patientSex: this.current_patient.patientSex,
                patientAge: this.current_patient.patientAge,
                visitTime: item.visitTime,
                visitStatus: item.visitStatus,
                visitTypeName: item.visitTypeName,
                patientId: this.current_patient.patientId,
                consulId: item.consultId
            }
            localStorage.setItem('consul_baseinfo', JSON.stringify(consul_baseinfo))
            this.$router.push({ path: '/consul', query: { consultId: item.consultId } })
        },
        initQw(){
            if(!Interface.isWorkWeChat()){
                this.hasUser = false;
            }

            let url = window.location.href
            var params = {
                uri: encodeURI(url),
                source_from:"yyh"
            }
            if(this.$route.path.indexOf('gb_user_detail') > -1){
                params.source_from = 'gaobo'
            }

            Interface.getData('get', Interface.wechat_share,params).then(res => {
                Interface.getData('get', Interface.gb_proxy.agent, params).then(agentRes => {
                    ww.register({
                        corpId: agentRes.data.corpid, // 必填，企业微信的corpid，必须与当前登录的企业一致
                        agentId: agentRes.data.agentid, // 必填，企业微信的应用id （e.g. 1000247）
                        jsApiList: [
                            'getCurExternalContact'
                        ], //必填，传入需要使用的接口名称
                        getConfigSignature() {
                            return {
                                timestamp: res.data.timestamp,
                                nonceStr: res.data.nonce_str,
                                signature: res.data.signature,
                            }
                        },
                        getAgentConfigSignature() {
                            return {
                                timestamp: agentRes.data.timestamp,
                                nonceStr: agentRes.data.nonce_str,
                                signature: agentRes.data.signature,
                            }
                        },
                    })

                    ww.getCurExternalContact().then(res => {
                        this.external_userid = res.userId
                        console.log('获取到的外部联系人ID：', this.external_userid)
                        this.fetch('baseinfo')
                    }, err => {
                        console.log('获取外部联系人信息失败：', err)
                        this.hasUser = false
                    })
                })
            })
        },
    },
    beforeMount() {
        // if(this.$route.path.indexOf('gb_user_detail') > -1){
        //     this.external_userid = 'wm3nDlPwAAiBm9bN9nnyLaSuwNGVcipw'
        //     this.fetch('baseinfo')
        // }else{
            this.initQw()
        // }
    },
}

</script>
<style lang="scss">
@import './index';

.historyShow{
    width: 300px;
    text-align: left;
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #404040;
    letter-spacing: 0;
    line-height: 22px;
    padding: 0 20px 20px;
}

.historyShow .close-pop{
    float: right;
    margin-right: 10px;

}

</style>



// WEBPACK FOOTER //
// src/views/co_user_detail/index.vue